import type { ClientStatusResponse } from '@shared/api/clientStatus.api.ts';

// Returns the policy value for the specified policy name and user type.
export const getPolicyValueByNameAndUserType = (
    policyName: string,
    userType: string,
    clientStatus: ClientStatusResponse,
): number =>
    clientStatus.passwordPolicyPerType
        .find((policyPerType) => policyPerType.userType === userType)
        ?.passwordPolicies.find((policy) => policy.name === policyName)?.passwordRequirementValue ?? 0;
